module.exports = __webpack_public_path__ + "img/Leo_Headshot-photoaidcom-cropped.3dcd32e9.JPG";